"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DETAILS_COUNTER = exports.DETAILS_CLOSE_BUTTON = exports.DETAILS = void 0;
const DETAILS = exports.DETAILS = 'details';
const DETAILS_CLOSE_BUTTON = exports.DETAILS_CLOSE_BUTTON = 'details-close-button';
const DETAILS_COUNTER = exports.DETAILS_COUNTER = 'details-counter';
